import { colors } from '../constants';
import { SHADOW_LEVEL3 } from '../shadows';
const styleOverrides = {
  badge: ({
    ownerState
  }) => ({
    boxShadow: 'none',
    border: `2px solid ${colors.commonColors.white}`,
    height: 24,
    minWidth: 24,
    borderRadius: 12,
    ...(ownerState.color === 'default' && {
      backgroundColor: colors.commonColors.white,
      boxShadow: SHADOW_LEVEL3
    })
  }),
  dot: {
    width: 10,
    height: 10,
    minWidth: 'unset',
    borderRadius: '50%'
  }
};
const defaultProps = {
  color: 'default'
};
export default {
  styleOverrides,
  defaultProps
};